import '@antv/x6-vue-shape';
import {Addon} from '@antv/x6';
import {isNullOrUnderfined} from '../../../utils/tool'

// 连接桩半径
const r = 8
// 连接点组
const ports = {
  groups: {
    // 输入链接桩群组定义
    top: {
      position: 'top',
      attrs: {
        circle: {
          r: r,
          magnet: true,
          stroke: '#CCCCCC',
          strokeWidth: 2,
          fill: '#fff',
        },
      },
    },
    // 输出链接桩群组定义
    bottom: {
      position: 'bottom',
      attrs: {
        circle: {
          r: r,
          magnet: true,
          stroke: '#CCCCCC',
          strokeWidth: 2,
          fill: '#fff',
        },
      },
    },
    left: {
      position: 'left',
      attrs: {
        circle: {
          r: r,
          magnet: true,
          stroke: '#CCCCCC',
          strokeWidth: 2,
          fill: '#fff',
        },
      },
    },
    right: {
      position: 'right',
      attrs: {
        circle: {
          r: r,
          magnet: true,
          stroke: '#CCCCCC',
          strokeWidth: 2,
          fill: '#fff',
        },
      },
    },
  },
  items: [
    {
      id: 'port1',
      group: 'top',
    },
    {
      id: 'port2',
      group: 'bottom',
    },
    {
      id: 'port3',
      group: 'left',
    },
    {
      id: 'port4',
      group: 'right',
    }
  ],
}
// 拖拽生成四边形或者圆形
export const startDragToGraph = (graph, type, url, e,width,height) => {
  let node = null
  switch ( type ) {
    case 'rect':
      node = createRect(graph)
      break;
    case 'circle':
      node = createCircle(graph)
      break;
    case 'polygon':
      node = createPolygon(graph)
      break;
    case 'text-block':
      node = createTextBox(graph)
      break;
    case 'image':
      node = createImage(graph, url,width,height)
      break;
  }
  const dnd = new Addon.Dnd({target: graph})
  dnd.start(node, e)
}

// 创建一个矩形
export function createRect(graph) {
  return graph.createNode({
    width: 100,
    height: 60,
    attrs: {
      label: {
        text: '矩形节点',
        fill: '#000000',
        fontSize: 14,
        textWrap: {
          width: -10,
          height: -10,
          ellipsis: true,
        },
      },
      body: {
        stroke: '#000000',
        strokeWidth: 1,
        fill: '#ffffff',
      }
    },
    ports: ports
  })
}

// 创建一个圆形
export function createCircle(graph) {
  return graph.createNode({
    shape: 'ellipse',
    width: 100,
    height: 100,
    attrs: {
      label: {
        text: '圆形节点',
        fill: '#000000',
        fontSize: 14,
        textWrap: {
          width: -20,
          height: -10,
          ellipsis: true,
        },
      },
      body: {
        stroke: '#000000',
        strokeWidth: 1,
        fill: '#ffffff',
      }
    },
    ports: ports
  })
}

// 创建一个菱形
export function createPolygon(graph) {
  return graph.createNode({
    shape: 'polygon',
    x: 40,
    y: 40,
    width: 120,
    height: 120,
    attrs: {
      label: {
        text: '菱形节点',
        fill: '#000000',
        fontSize: 14,
        textWrap: {
          width: -50,
          height: '70%',
          ellipsis: true,
        },
      },
      body: {
        fill: '#ffffff',
        stroke: '#000000',
        refPoints: '0,10 10,0 20,10 10,20',
        strokeWidth: 1,
      },
    },
    ports: ports
  })
}

// 创建一个文本框
export function createTextBox(graph) {
  return graph.createNode({
    shape: 'text-block',
    width: 160,
    height: 50,
    attrs: {
      label: {
        text: '这是一个多行文本框',
        fill: '#000000',
        fontSize: 14
      },
      body: {
        fill: '#ffffff',
        stroke: '#000000',
        strokeWidth: 1,
        rx: 4,
        ry: 4
      },
    },
    ports: ports
  })
}

// 创建一个图片
export function createImage(graph, url, width, height) {
  // 设置默认宽高
  if (isNullOrUnderfined(width)) {
    width = 70
  }
  if (isNullOrUnderfined(height)) {
    height = 60
  }
  return graph.createNode({
    shape: 'image',
    width: width,
    height: height,
    imageUrl: url,
    attrs: {
      label: {
        text: '',
        fontSize: 14,
        fill: '#000000',
        refX: 0.5,
        refY: '100%',
        refY2: 4,
        textAnchor: 'middle',
        textVerticalAnchor: 'top',
      }
    },
    ports: ports
  })
}
